/* Independent instances also survive Shopify theme-editor section reloads. */
if (!customElements.get('ndl-new-hero')) {
  customElements.define('ndl-new-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('.ndl-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.ndl-hero__dot'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.paused = false;
      this.selected = false;
      this.hovered = false;
      this.activate(0);
      this.dots.forEach((dot) => dot.addEventListener('click', () => {
        this.show(Number(dot.dataset.go));
        this.start();
      }, options));
      this.pauseButton = this.querySelector('.ndl-hero__pause');
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.textContent = this.paused ? 'Weiter' : 'Pause';
        this.start();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.start()), options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      this.motion.addEventListener('change', () => this.start(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.ndl-hero__slide');
        if (!slide) return;
        this.selected = true;
        this.stop();
        clearTimeout(this.pending);
        this.pending = null;
        this.slides.forEach((item) => this.reset(item));
        this.activate(Number(slide.dataset.index));
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.selected = false;
        this.start();
      }, options);
      this.start();
    }

    disconnectedCallback() {
      this.controller.abort();
      this.stop();
      clearTimeout(this.pending);
      this.pending = null;
    }

    activate(index) {
      this.current = index;
      this.slides.forEach((slide, number) => {
        slide.classList.toggle('is-active', number === index);
        slide.inert = number !== index;
        slide.setAttribute('aria-hidden', String(number !== index));
      });
      this.dots.forEach((dot, number) => {
        dot.classList.toggle('is-active', number === index);
        dot.setAttribute('aria-current', String(number === index));
      });
    }

    reset(slide) {
      slide.classList.add('is-resetting');
      slide.classList.remove('is-active', 'is-leaving');
      slide.inert = true;
      slide.setAttribute('aria-hidden', 'true');
      void slide.offsetWidth;
      slide.classList.remove('is-resetting');
    }

    show(next) {
      if (!this.slides[next] || (next === this.current && !this.pending)) return;
      clearTimeout(this.pending);
      this.slides.forEach((slide, index) => {
        if (index !== this.current) this.reset(slide);
      });
      const leaving = this.slides[this.current];
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      leaving.inert = true;
      leaving.setAttribute('aria-hidden', 'true');
      this.pending = setTimeout(() => {
        this.pending = null;
        this.reset(leaving);
        this.activate(next);
      }, this.motion.matches ? 0 : Number(this.dataset.speed) + Number(this.dataset.gap));
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    start() {
      this.stop();
      if (!this.isConnected || this.dataset.autoplay !== 'true' || this.slides.length < 2 ||
          this.paused || this.selected || this.hovered || this.motion.matches ||
          document.hidden || this.contains(document.activeElement)) return;
      this.timer = setInterval(() => this.show((this.current + 1) % this.slides.length),
        Number(this.dataset.interval) + Number(this.dataset.speed) * 2 +
        Number(this.dataset.gap) + Number(this.dataset.delay));
    }
  });
}
